import FeaturesContainer from './FeaturesContainer'

const ArSearch = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'ar-search'} nextUrl={'sos-button'} />
};

export default ArSearch
